import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  header: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    letterSpacing: 1.5,
    marginTop: 12,
    display: "block",
  },
  upperCase: {
    textTransform: "uppercase",
  },
});

const FormSectionHeader = ({ classes, label, uppercase }) => (
  <span className={`${classes.header} ${uppercase ? classes.upperCase : ""}`}>
    {label}
  </span>
);

export default withStyles(styles)(FormSectionHeader);
